export default {
  'on-your-side': {
    src: '//images.ctfassets.net/l0gi7dcsjajc/7o7rjTtXwREGKPUToli5hn/a534a194a7106dd51e7eb9c04de8efd3/on-your-side.jpg',
    sources: [
      {
        media: '(max-width: 991px)',
        srcsets: [
          '//images.ctfassets.net/l0gi7dcsjajc/7o7rjTtXwREGKPUToli5hn/a534a194a7106dd51e7eb9c04de8efd3/on-your-side.jpg?h=900&q=70&fm=webp 3x',
          '//images.ctfassets.net/l0gi7dcsjajc/7o7rjTtXwREGKPUToli5hn/a534a194a7106dd51e7eb9c04de8efd3/on-your-side.jpg?h=600&q=80&fm=webp 2x',
          '//images.ctfassets.net/l0gi7dcsjajc/7o7rjTtXwREGKPUToli5hn/a534a194a7106dd51e7eb9c04de8efd3/on-your-side.jpg?h=300&q=90&fm=webp 1x'
        ],
        type: 'image/webp'
      },
      {
        media: '(min-width: 992px)',
        srcsets: [
          '//images.ctfassets.net/l0gi7dcsjajc/7o7rjTtXwREGKPUToli5hn/a534a194a7106dd51e7eb9c04de8efd3/on-your-side.jpg?h=2100&q=70&fm=webp 3x',
          '//images.ctfassets.net/l0gi7dcsjajc/7o7rjTtXwREGKPUToli5hn/a534a194a7106dd51e7eb9c04de8efd3/on-your-side.jpg?h=1400&q=80&fm=webp 2x',
          '//images.ctfassets.net/l0gi7dcsjajc/7o7rjTtXwREGKPUToli5hn/a534a194a7106dd51e7eb9c04de8efd3/on-your-side.jpg?h=700&q=90&fm=webp 1x'
        ],
        type: 'image/webp'
      },
      {
        media: '(max-width: 991px)',
        srcsets: [
          '//images.ctfassets.net/l0gi7dcsjajc/7o7rjTtXwREGKPUToli5hn/a534a194a7106dd51e7eb9c04de8efd3/on-your-side.jpg?h=900&q=70&fm=jpeg 3x',
          '//images.ctfassets.net/l0gi7dcsjajc/7o7rjTtXwREGKPUToli5hn/a534a194a7106dd51e7eb9c04de8efd3/on-your-side.jpg?h=600&q=80&fm=jpeg 2x',
          '//images.ctfassets.net/l0gi7dcsjajc/7o7rjTtXwREGKPUToli5hn/a534a194a7106dd51e7eb9c04de8efd3/on-your-side.jpg?h=300&q=90&fm=jpeg 1x'
        ],
        type: 'image/jpeg'
      },
      {
        media: '(min-width: 992px)',
        srcsets: [
          '//images.ctfassets.net/l0gi7dcsjajc/7o7rjTtXwREGKPUToli5hn/a534a194a7106dd51e7eb9c04de8efd3/on-your-side.jpg?h=2100&q=70&fm=jpeg 3x',
          '//images.ctfassets.net/l0gi7dcsjajc/7o7rjTtXwREGKPUToli5hn/a534a194a7106dd51e7eb9c04de8efd3/on-your-side.jpg?h=1400&q=80&fm=jpeg 2x',
          '//images.ctfassets.net/l0gi7dcsjajc/7o7rjTtXwREGKPUToli5hn/a534a194a7106dd51e7eb9c04de8efd3/on-your-side.jpg?h=700&q=90&fm=jpeg 1x'
        ],
        type: 'image/jpeg'
      }
    ]
  },
  'on-your-side-spacer': {
    src: '//images.ctfassets.net/l0gi7dcsjajc/5Kb2OrebKOQVRAUw0uJA4b/4dd42ed859297e39fc5697d559c5f0c0/on-your-side-spacer-desktop.jpg',
    sources: [
      {
        media: '(max-width: 991px)',
        srcsets: [
          '//images.ctfassets.net/l0gi7dcsjajc/2Bc32qH7bhXHIOfaT8lwfc/30a7bb861b6fb0251e65b07ef8b08ae3/on-your-side-spacer-mobile.jpg?h=900&q=70&fm=webp 3x',
          '//images.ctfassets.net/l0gi7dcsjajc/2Bc32qH7bhXHIOfaT8lwfc/30a7bb861b6fb0251e65b07ef8b08ae3/on-your-side-spacer-mobile.jpg?h=600&q=80&fm=webp 2x',
          '//images.ctfassets.net/l0gi7dcsjajc/2Bc32qH7bhXHIOfaT8lwfc/30a7bb861b6fb0251e65b07ef8b08ae3/on-your-side-spacer-mobile.jpg?h=300&q=90&fm=webp 1x'
        ],
        type: 'image/webp'
      },
      {
        media: '(min-width: 992px)',
        srcsets: [
          '//images.ctfassets.net/l0gi7dcsjajc/5Kb2OrebKOQVRAUw0uJA4b/4dd42ed859297e39fc5697d559c5f0c0/on-your-side-spacer-desktop.jpg?h=2100&q=70&fm=webp 3x',
          '//images.ctfassets.net/l0gi7dcsjajc/5Kb2OrebKOQVRAUw0uJA4b/4dd42ed859297e39fc5697d559c5f0c0/on-your-side-spacer-desktop.jpg?h=1400&q=80&fm=webp 2x',
          '//images.ctfassets.net/l0gi7dcsjajc/5Kb2OrebKOQVRAUw0uJA4b/4dd42ed859297e39fc5697d559c5f0c0/on-your-side-spacer-desktop.jpg?h=700&q=90&fm=webp 1x'
        ],
        type: 'image/webp'
      },
      {
        media: '(max-width: 991px)',
        srcsets: [
          '//images.ctfassets.net/l0gi7dcsjajc/2Bc32qH7bhXHIOfaT8lwfc/30a7bb861b6fb0251e65b07ef8b08ae3/on-your-side-spacer-mobile.jpg?h=900&q=70&fm=jpeg 3x',
          '//images.ctfassets.net/l0gi7dcsjajc/2Bc32qH7bhXHIOfaT8lwfc/30a7bb861b6fb0251e65b07ef8b08ae3/on-your-side-spacer-mobile.jpg?h=600&q=80&fm=jpeg 2x',
          '//images.ctfassets.net/l0gi7dcsjajc/2Bc32qH7bhXHIOfaT8lwfc/30a7bb861b6fb0251e65b07ef8b08ae3/on-your-side-spacer-mobile.jpg?h=300&q=90&fm=jpeg 1x'
        ],
        type: 'image/jpeg'
      },
      {
        media: '(min-width: 992px)',
        srcsets: [
          '//images.ctfassets.net/l0gi7dcsjajc/5Kb2OrebKOQVRAUw0uJA4b/4dd42ed859297e39fc5697d559c5f0c0/on-your-side-spacer-desktop.jpg?h=2100&q=70&fm=jpeg 3x',
          '//images.ctfassets.net/l0gi7dcsjajc/5Kb2OrebKOQVRAUw0uJA4b/4dd42ed859297e39fc5697d559c5f0c0/on-your-side-spacer-desktop.jpg?h=1400&q=80&fm=jpeg 2x',
          '//images.ctfassets.net/l0gi7dcsjajc/5Kb2OrebKOQVRAUw0uJA4b/4dd42ed859297e39fc5697d559c5f0c0/on-your-side-spacer-desktop.jpg?h=700&q=90&fm=jpeg 1x'
        ],
        type: 'image/jpeg'
      }
    ]
  }
}
